<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('personalities')"
      :columns="columns"
      :column_search="true"
      resource_url="/assistant/personality/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <personality-modal ref="personality_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  input_alert,
  success_message,
  put,
  format_currency,
} from "@/utils";
import PersonalityModal from "./personality_modal/Index.vue";

export default {
  name: "PersonalityDatatable",
  components: { GenericTable, PersonalityModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          data: (row) => {
            return `<div class="title is-6">${row.name}</div>
            <div class="subtitle is-6">${row.settings.ai_engine}</div>`;
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   width: "80%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return `<div class="content"><ul>
        //       <li>${row.prompt}</li>
        //       <li>${row.response}</li>
        //     </ul></div>`;
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("create api key"),
                icon: "fa fa-plus has-text-success",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  input_alert({
                    title: v.$t("enter api key name"),
                    text: v.$t("this name is for your reference only"),
                    input: "text",
                  }).then((result) => {
                    put("/assistant/api-key", {
                      name: result,
                      personality_uuid: row.uuid,
                    })
                      .then(() => {
                        success_message(v.$t("api key created"));
                      })
                      .catch((error) => {
                        error_message(error);
                      });
                  });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.personality_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete personality?"),
                    v,
                    () => {
                      del("/assistant/personality", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.personality_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
